export function Loader({ label = 'Loading...' }) {
  return (
    <div
      style={{
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 12,
        //background: 'var(--erp-bg, #f4f6f8)',
        color: 'var(--erp-text, #1a1a1a)',
      }}
    >
      <div className="erp-spinner" />
      <span>{label}</span>
    </div>
  );
}
